<template>
  <div class="box-block-10 auto">
    <p class="current-menu gray66">
      <i class="fa fa-home grayae"></i>
      {{$route.path === '/data/brand/home' ? '隅西科技-虚拟员工230543-Haiyang-数字员工-客户部-数据分析' : currentRoute.name}}
    </p>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right" class="subnav-rightbox">
      <el-breadcrumb-item v-for="(item, index) in routerList" :key="index">{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item>
    </el-breadcrumb> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SubMenu',
  props: {
    src: ''
  },
  data () {
    return {
      currentRoute: '',
      routerList: []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  watch: {
    '$route': function (val) {
      this.renderSubMenu()
    }
  },
  methods: {
    renderSubMenu () {
      this.routerList = []
      let routerArr = this.$route.path.split('/')
      routerArr.shift()
      this.routerList.push(this.sidebar[routerArr[0]])
      if (this.sidebar[routerArr[0]].menu) {
        this.routerList.push(this.sidebar[routerArr[0]].menu[routerArr[1]])
        if (this.sidebar[routerArr[0]].menu[routerArr[1]].menu) {
          this.currentRoute = this.sidebar[routerArr[0]].menu[routerArr[1]].menu[routerArr[2]]
        } else {
          this.currentRoute = this.sidebar[routerArr[0]].menu[routerArr[1]]
        }
      }
      this.routerList.reverse()
      console.log(this.$route.path)
    }
  },
  created () {
    this.renderSubMenu()
  }
}
</script>
<style>
.current-menu {
  float: left;
  font-size: 16px;
  line-height: 30px;
}
.current-menu i {
  font-size: 16px;
  margin-right: 11px;
}
.subnav-rightbox {
  float: left;
  margin-left: 30px;
}
.subnav-rightbox .el-breadcrumb__inner, .subnav-rightbox .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #aeaeae;
  font-size: 14px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/default/SubMenu.vue